import cn from 'classnames';
import React from 'react';

import Col from './Col';
import styles from './Grid.module.scss';
import { GutterSize } from './types';
import { getGutterValue } from './utils';

type HtmlProps = Pick<
  React.HTMLProps<HTMLDivElement>,
  'children' | 'className' | 'style'
>;

export interface GridProps extends HtmlProps {
  gutter?: GutterSize;
  // NB: component isn't responsive because our widget depends on the size of its
  // container moreso than the size of the page.  setup a resize monitor on the
  // widget and use that to control the `orientation` prop
  orientation?: 'horizontal' | 'vertical';
  wrap?: React.CSSProperties['flexWrap'];
}

const GridComponent = React.forwardRef<HTMLDivElement, GridProps>(
  (
    {
      children,
      className,
      gutter = 'md',
      orientation = 'horizontal',
      style,
      wrap,
    },
    ref,
  ) => (
    <div
      className={cn(
        styles.grid,
        {
          [styles.grid__vertical]: orientation === 'vertical',
        },
        className,
      )}
      ref={ref}
      style={{
        ...style,
        ['--gutter-size' as string]: getGutterValue(gutter),
        ['--wrap' as string]: wrap,
      }}
    >
      {children}
    </div>
  ),
);

const Grid = Object.assign(GridComponent, { Col });

Grid.Col = Col;

export default Grid;
